import React from 'react';
import BentoGrid from '../components/dashboard/BentoGrid';

const Home = () => {
    return (
        <div className="home-page">
            <BentoGrid />
        </div>
    );
};

export default Home;
